// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HelpIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HelpIcon" ref={forwardedRef} {...props}>
      <path d="M11.746 8.5c0 .195-.066.336-.219.495-.182.188-.439.353-.805.584l-.057.036C10.035 10.012 9 10.664 9 12h1.5c0-.436.273-.677 1.024-1.152l.052-.033c.314-.198.716-.451 1.03-.778.363-.375.64-.874.64-1.537 0-1.657-1.456-3-3.25-3s-3.25 1.343-3.25 3v.044V8.5l1.5.001c0-.718.668-1.5 1.75-1.5s1.75.782 1.75 1.5" />
      <path d="M9.75 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
      <path d="M1.996 10.008a8 8 0 1 0 16 0 8 8 0 0 0-16 0m8 6.5a6.5 6.5 0 1 1 0-13 6.5 6.5 0 0 1 0 13" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HelpIcon = /* @__PURE__ */ Object.assign(HelpIconComponent, {
  displayName: 'HelpIcon',
});
